export function isNativePushPlatform(platform: string | undefined): boolean {
  return platform === 'android' || platform === 'ios';
}

export function buildGoogleMapsScriptUrl(
  apiKey: string,
  callbackName: string,
  language = 'es'
): string {
  const params = new URLSearchParams({
    key: apiKey,
    callback: callbackName,
    libraries: 'places',
    loading: 'async',
    language,
  });

  return `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
}
